<template>
  <div>
    <el-row>
      <el-button class="tfam-button" plain @click="submitUpdate">更新並儲存</el-button>
    </el-row>
    <el-row :gutter="20">
      <!-- 展覽 -->
      <el-col :span="12">
        <el-table
          ref="singleTable"
          :data="exhibition"
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
          :stripe="true"
          highlight-current-row
          style="width: 100%">
          <el-table-column label="展覽">
            <el-table-column
              type="role"
              label="角色"
              width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.role | roleFilter }}</span>
              </template>
            </el-table-column>
            <el-table-column
              type="create"
              label="新增"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.create"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="remove"
              label="刪除"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.remove"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="unPub"
              label="下架"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.unPub"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="pub"
              label="上架"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.pub"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="read"
              label="讀取"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.read"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="read"
              label="編輯"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.edit"></el-checkbox>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
      <!-- 展品 -->
      <el-col :span="12">
        <el-table
          ref="singleTable"
          :data="collection"
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
          :stripe="true"
          highlight-current-row
          style="width: 100%">
          <el-table-column label="展品">
            <el-table-column
              type="role"
              label="角色"
              width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.role | roleFilter }}</span>
              </template>
            </el-table-column>
            <el-table-column
              type="create"
              label="新增"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.create"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="remove"
              label="刪除"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.remove"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="read"
              label="讀取"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.read"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="sortable"
              label="排序"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.sortable"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="read"
              label="編輯"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.edit"></el-checkbox>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <!-- 藝術家 -->
      <el-col :span="12">
        <el-table
          ref="singleTable"
          :data="artist"
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
          :stripe="true"
          highlight-current-row
          style="width: 100%">
          <el-table-column label="藝術家">
            <el-table-column
              type="role"
              label="角色"
              width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.role | roleFilter }}</span>
              </template>
            </el-table-column>
            <el-table-column
              type="create"
              label="新增"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.create"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="remove"
              label="刪除"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.remove"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="read"
              label="讀取"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.read"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="read"
              label="編輯"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.edit"></el-checkbox>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
      <!-- 裝置 -->
      <el-col :span="12">
        <el-table
          ref="singleTable"
          :data="beacon"
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
          :stripe="true"
          highlight-current-row
          style="width: 100%">
          <el-table-column label="裝置">
            <el-table-column
              type="role"
              label="角色"
              width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.role | roleFilter }}</span>
              </template>
            </el-table-column>
            <el-table-column
              type="create"
              label="新增"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.create"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="remove"
              label="刪除"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.remove"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="read"
              label="讀取"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.read"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="read"
              label="編輯"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.edit"></el-checkbox>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <!-- 裝置事件 -->
      <el-col :span="12">
        <el-table
          ref="singleTable"
          :data="beaconEvent"
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
          :stripe="true"
          highlight-current-row
          style="width: 100%">
          <el-table-column label="裝置推播">
            <el-table-column
              type="role"
              label="角色"
              width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.role | roleFilter }}</span>
              </template>
            </el-table-column>
            <el-table-column
              type="create"
              label="新增"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.create"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="remove"
              label="刪除"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.remove"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="read"
              label="讀取"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.read"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="read"
              label="編輯"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.edit"></el-checkbox>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
      <!-- 推播 -->
      <el-col :span="12">
        <el-table
          ref="singleTable"
          :data="notification"
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
          :stripe="true"
          highlight-current-row
          style="width: 100%">
          <el-table-column label="推播">
            <el-table-column
              type="role"
              label="角色"
              width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.role | roleFilter }}</span>
              </template>
            </el-table-column>
            <el-table-column
              type="create"
              label="新增"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.create"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="remove"
              label="刪除"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.remove"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="read"
              label="讀取"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.read"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              property="read"
              label="編輯"
              min-width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.permission.edit"></el-checkbox>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row :gutter="20">
    </el-row>
  </div>
</template>

<script>
  import { fetchPermissionList, updatePermission } from "../../api/permission";

  export default {
    name: "PermissionEdit",
    data() {
      return {
        exhibition: [],
        activity: [],
        artist: [],
        collection: [],
        beacon: [],
        beaconEvent: [],
        notification: []
      }
    },
    filters: {
      roleFilter: function (role) {
        if (role === 'Admin') {
          return '管理員'
        } else if (role === 'VolunteerA') {
          return '北美館志工 A 組'
        } else if (role === 'VolunteerB') {
          return '北美館志工 B 組'
        }
      }
    },
    methods: {
      headerCellStyle(row, column, rowIndex, columnIndex) {
        return 'text-align:center'
      },
      cellStyle(row, column, rowIndex, columnIndex) {
        return 'text-align:center'
      },
      getPermission() {
        fetchPermissionList().then(response => {
          this.exhibition = response.data.filter(x => x['type'] === 'exhibition');
          // this.activity = response.data.filter(x => x['type'] === 'activity');
          this.artist = response.data.filter(x => x['type'] === 'artist');
          this.collection = response.data.filter(x => x['type'] === 'collection');
          this.beacon = response.data.filter(x => x['type'] === 'beacon');
          this.beaconEvent = response.data.filter(x => x['type'] === 'beacon_event');
          this.notification = response.data.filter(x => x['type'] === 'notification');
        }).catch(err => {
        })
      },
      submitUpdate: async function() {
        try {
          const updatePromise = [];
          for (const i in this.exhibition) {
            updatePromise.push(updatePermission(this.exhibition[i]['id'], this.exhibition[i]));
          }
          for (const i in this.artist) {
            updatePromise.push(updatePermission(this.artist[i]['id'], this.artist[i]));
          }
          for (const i in this.collection) {
            updatePromise.push(updatePermission(this.collection[i]['id'], this.collection[i]));
          }
          for (const i in this.beacon) {
            updatePromise.push(updatePermission(this.beacon[i]['id'], this.beacon[i]));
          }
          for (const i in this.beaconEvent) {
            updatePromise.push(updatePermission(this.beaconEvent[i]['id'], this.beaconEvent[i]));
          }
          for (const i in this.notification) {
            updatePromise.push(updatePermission(this.notification[i]['id'], this.notification[i]));
          }
          await Promise.all(updatePromise);
          return Promise.resolve(true);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    },
    mounted() {
      this.getPermission();
    }
  }
</script>

<style scoped>
  .el-row {
    margin-bottom: 20px;
  &:last-child {
     margin-bottom: 0;
   }
  }
</style>
